module.exports = __webpack_public_path__ + "img/synchronize.3b0a5cb0.gif";